import { MARKETPLACE } from "@acc/shared"
import type { WbTokenInfo } from "@acc/shared"
import { RecodeSamsonYaType } from "./../components/Samson/UpdateStocks/ya/recode"
import { AxiosResponse } from "axios"
import { SysApi } from "./sysapi"
import { PriceType, SHOP_IDENT } from "../app/reducers/settingsReducer"
import { RecodeMetroType } from "../components/UpdateStoksMetro/types"
import { PodrOrdersType } from "../app/reducers/updateStoksPodruzhka"
import {
  IRecodeOzonKatren,
  RecodeKatren,
} from "../components/FormKatrenOrder/FormKatrenOrder"
import { RecodeSamsonWbType } from "../components/Samson/UpdateStocks/wb/recode"
import { ReportItem } from "../components/reports/wb/types"
import { BaseWBRecodeItemType } from "../components/ShopComponent/types"

export class BaseApi extends SysApi {
  // static register(data: { username: string; password: string }) {
  //   return axios.post(this.baseUrl + "register", data, {
  //     headers: {
  //       "Access-Control-Allow-Origin": "*",
  //       "Access-Control-Allow-Credentials": "true",
  //       "Access-Control-Request-Method": "POST",
  //       // "Content-Type": "text/html",
  //     },
  //   })
  // }

  static testProtect() {
    return this.get(this.baseUrl + "protected")
  }

  static searchByVendorCode(vendorCodes: string[]) {
    return this.post(this.baseUrl + "api/searchByVendorCode", {
      vendorCodes,
    }).then((resp) => resp.data)
  }

  // static uploadXlsxFile(data: FormData) {
  //   return this.post(this.baseUrl + "api/uploadKtrXslx", data, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //     },
  //   })
  // }
  // static deleteXlsxFile() {
  //   return this.delete(this.baseUrl + "api/deleteKtrXslx")
  // }
  // static deleteStockXlsxFile() {
  //   return this.delete(this.baseUrl + "api/deleteXslxForStoks")
  // }
  // static isKtrXslxExists() {
  //   return this.get(this.baseUrl + "api/ktrXslxExists")
  // }

  // static formCards() {
  //   return this.get(this.baseUrl + "api/formCards")
  // }

  // static uploadStoks() {
  //   return this.get(this.baseUrl + "api/uploadStoks")
  // }
  // static uploadState() {
  //   return this.get(this.baseUrl + "api/uploadState", undefined, false)
  // }

  // static updateStoks(warehouseId: number | string) {
  //   return this.post(this.baseUrl + "api/updateStoks", {
  //     warehouseId,
  //   })
  // }
  // static downloadRecodes() {
  //   return this.get(this.baseUrl + "recode/recoding.csv")
  // }

  // static async uploadRecodesFile(data: FormData) {
  //   const response = await this.post(
  //     this.baseUrl + "api/uploadRecodingForm",
  //     data,
  //     {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     },
  //   )

  //   return response
  // }
  // static updatePrices = () => {
  //   return this.get(this.baseUrl + "api/updatePrices")
  // }

  static setWBExpiration = (
    data: { id: number; article: string; expDate?: string }[],
  ) => {
    return this.post(this.baseUrl + "api/wb/expiration", { data })
  }

  static getNewOrders = () => {
    return this.get(this.baseUrl + "api/wb/katren/orders")
  }

  static getOzonNewOrders = () => {
    return this.get(this.baseUrl + "api/ozon/orders/update")
  }

  static getOrdersState = () => {
    return this.get(this.baseUrl + "api/ordersState")
  }

  static updateSupplies = () => {
    return this.get(this.baseUrl + "api/wb/katren/supplies")
  }

  static addOrdersToSupplies = (supplyId: number, orderIds: number[]) => {
    return this.post(this.baseUrl + "api/addOrdersToSupplies", {
      supplyId,
      orderIds,
    })
  }
  static createNewSuppliesAndAddOrders = (name: string, orderIds: number[]) => {
    return this.post(this.baseUrl + "api/createNewSuppliesAndAddOrders", {
      name,
      orderIds,
    })
  }
  static getSuppliesWithOrders = (supplyId: string) => {
    return this.post(this.baseUrl + "api/wb/katren/supplies", {
      supplyId,
    })
  }

  static downloadFormOrderListForKatren() {
    return this.get(this.baseUrl + "recode/ordersToKtrn.xlsx")
  }

  static updateStoksICONState() {
    return this.get(this.baseUrl + "api/icon/StoksState", undefined, false)
  }

  static updatePricesICON(cookie: string) {
    return this.post(this.baseUrl + "api/icon/updatePrices", { cookie })
  }

  static settings() {
    return this.get(this.baseUrl + "api/settings")
  }

  static updateShopName(shopName: string) {
    return this.put(this.baseUrl + "api/shopName", { shopName })
  }

  static updatePriceParams(
    shop: string,
    price: PriceType,
    amountParams?: { count: number; amount: number }[],
  ) {
    return this.post(this.baseUrl + "api/updateParamPrice", {
      shop,
      price,
      amountParams,
    })
  }

  static updateShopCalcIdent(shop: string, calcIdent: string) {
    return this.put(this.baseUrl + "api/shops/calc-ident", {
      shop,
      calcIdent,
    })
  }

  static katrenUpdateStocksState() {
    return this.get(this.baseUrl + "api/katren/state", undefined, false)
  }

  static katrenUpdateStoks(
    selectedStorageId: string,
    updatePrices: boolean,
    updateStocks: boolean,
    isReturnToPromo?: boolean,
  ) {
    return this.post(
      this.baseUrl + "api/wb/katren/update",
      { selectedStorageId, updatePrices, updateStocks, isReturnToPromo },
      undefined,
      true,
    )
  }

  static katrenUpdateStoksForOzon(
    selectedStorageId: string,
    updatePrices: boolean,
    updateStocks: boolean,
  ) {
    return this.post(
      this.baseUrl + "api/ozon/katrenUpdateStoks",
      { selectedStorageId, updatePrices, updateStocks },
      undefined,
      true,
    )
  }

  static uploadDataFromKatren(
    data: {
      name: string
      amount: number
      price: number
      priceInfo?:
        | {
            price: number
            storage?: string | undefined
          }[]
        | undefined
    }[],
    fileName?: string,
  ) {
    return this.post(
      this.baseUrl + "api/katren/data",
      { rows: data, fileName },
      undefined,
      true,
    )
  }

  static deleteWBKatrenRecode() {
    return this.delete(this.baseUrl + "api/wb/katren/recode", undefined, true)
  }

  static deleteCurrentDataKatrenForOzon() {
    return this.delete(
      this.baseUrl + "api/ozon/deleteCurrentDataKatren",
      undefined,
      true,
    )
  }

  static deleteCurrentDataKatrenForYandex() {
    return this.delete(
      this.baseUrl + "api/yandex/katren/recode",
      undefined,
      true,
    )
  }

  static uploadCurrentDataKatrenForYandex(data: FormData) {
    return this.post(
      this.baseUrl + "api/yandex/katren/recode",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      true,
    )
  }

  static loadRecodeKatrenYandex() {
    return this.get(
      this.baseUrl + "api/yandex/katren/recode",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static uploadWBKatrenRecode(data: FormData) {
    return this.post(
      this.baseUrl + "api/wb/katren/recode",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      true,
    )
  }

  static uploadCurrentDataKatrenForOzon(data: FormData) {
    return this.post(
      this.baseUrl + "api/ozon/uploadCurrentDataKatren",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      true,
    )
  }

  static deleteDataFromKatren() {
    return this.delete(this.baseUrl + "api/katren/data", undefined, true)
  }
  static podruzhkaUpdateStoks(
    selectedStorageId: string,
    updatePrices: boolean,
    updateStocks: boolean,
  ) {
    return this.post(
      this.baseUrl + "api/podruzhka/update",
      {
        selectedStorageId,
        updatePrices,
        updateStocks,
      },
      undefined,
      true,
    )
  }

  static podruzhkaUpdateStoksState() {
    return this.get(this.baseUrl + "api/podruzhka/state", undefined, true)
  }

  static deleteCurrentDataPodruzhka() {
    return this.delete(
      this.baseUrl + "api/podruzhka/delete/data",
      undefined,
      true,
    )
  }

  static uploadCurrentDataPodruzhka(data: any) {
    return this.post(
      this.baseUrl + "api/podruzhka/upload/data",
      { rows: data },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      true,
    )
  }

  static podruzhkaOrders() {
    return this.get<{ data: PodrOrdersType; success: boolean }>(
      this.baseUrl + "api/podruzhka/orders",
      undefined,
      true,
    )
  }

  static addSupplyToSimalandCart = (
    supplyIds: (string | number)[],
    shopIdent: string,
    clearCart?: boolean,
  ) => {
    return this.post<{
      success: boolean
      data: {
        added: { item_sid: number | string; qty: number }[]
        errArticles: string[]
      }
    }>(this.baseUrl + "api/simaland/supply/cart", {
      supplyIds,
      shopIdent,
      clearCart,
    })
  }

  static getSuppliesPodrOrdersInfo = <
    T = {
      success: boolean
      data: {
        orders: { productId: string; quantity: number }[]
        errArticles: string[]
      }
    },
  >(
    supplyId: string,
  ): Promise<AxiosResponse<T>> => {
    return this.post<T>(this.baseUrl + "api/podruzhka/supply/orders", {
      supplyId,
    })
  }

  static metroUpdateStoks(
    selectedStorageId: string,
    updatePrices: boolean,
    updateStocks: boolean,
  ) {
    return this.post(
      this.baseUrl + "api/metro/update",
      {
        selectedStorageId,
        updatePrices,
        updateStocks,
      },
      undefined,
      true,
    )
  }

  static metroUpdateStoksState() {
    return this.get(this.baseUrl + "api/metro/state", undefined, true)
  }

  static deleteRecodeMetro() {
    return this.delete(
      this.baseUrl + "api/metro/delete/recode",
      undefined,
      true,
    )
  }

  static uploadRecodeMetro(data: RecodeMetroType[]) {
    return this.post(
      this.baseUrl + "api/metro/upload/recode",
      { rows: data },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      true,
    )
  }

  static getWBKatrenRecode(): Promise<{
    items: RecodeKatren
    success: boolean
  }> {
    return this.get<{ items: RecodeKatren; success: boolean }>(
      this.baseUrl + "api/wb/katren/recode",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static loadOzonRecodeKatren(): Promise<{
    items: IRecodeOzonKatren
    success: boolean
  }> {
    return this.get<{ items: IRecodeOzonKatren; success: boolean }>(
      this.baseUrl + "api/ozon/katren/recode",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static logForKatrenWb() {
    return this.get(
      this.baseUrl + "api/audit?shop=KATREN&marketplace=wildberries",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static logForKatrenOzon() {
    return this.get(
      this.baseUrl + "api/audit?shop=KATREN&marketplace=ozon",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static logForKatrenYandex() {
    return this.get(
      this.baseUrl + "api/audit?shop=KATREN&marketplace=yandex",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static logForSamsonWb() {
    return this.get(
      this.baseUrl + "api/audit?shop=SAMSON&marketplace=wildberries",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static logForSamsonYa() {
    return this.get(
      this.baseUrl + "api/audit?shop=SAMSON&marketplace=yandex",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static logByShopIdent(shop: string) {
    return this.get(
      this.baseUrl + `api/audit?shop=${shop}`,
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static auditFormOrderFile(
    shop: string,
    marketplace?: string,
    type?: string,
    value?: string,
  ) {
    return this.get(
      this.baseUrl +
        `api/audit?shop=${shop}&marketplace=${marketplace}&type=${type}&value=${value}`,
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static putAuditFormOrderFile(
    data: {
      shop: string
      marketplace?: string
      type?: string
      value?: string
    }[],
  ) {
    return this.put(this.baseUrl + `api/audit`, { data }, undefined, false)
  }

  static katrenUpdateStoksForYandex(
    selectedStorageId: string,
    updatePrices: boolean,
    updateStocks: boolean,
  ) {
    return this.post(
      this.baseUrl + "api/yandex/katren/update/stocks",
      { selectedStorageId, updatePrices, updateStocks },
      undefined,
      true,
    )
  }

  // Samson
  static samsonState() {
    return this.get(this.baseUrl + "api/samson/state", undefined, true)
  }

  static samsonUpdateStocks(
    selectedStorageId: string,
    updatePrices: boolean,
    updateStocks: boolean,
  ) {
    return this.post(
      this.baseUrl + "api/wb/samson/update",
      {
        selectedStorageId,
        updatePrices,
        updateStocks,
      },
      undefined,
      true,
    )
  }

  static samsonWbResetStocks(selectedStorageId: string) {
    return this.post<{ success: boolean; message: string }>(
      this.baseUrl + "api/wb/samson/reset",
      {
        selectedStorageId,
      },
      undefined,
      true,
    )
  }

  static samsonYaResetStocks(selectedStorageId: string) {
    return this.post<{ success: boolean; message: string }>(
      this.baseUrl + "api/ya/samson/reset",
      {
        selectedStorageId,
      },
      undefined,
      true,
    )
  }

  static samsonYaUpdateStocks(
    selectedStorageId: string,
    updatePrices: boolean,
    updateStocks: boolean,
  ) {
    return this.post(
      this.baseUrl + "api/ya/samson/update",
      {
        selectedStorageId,
        updatePrices,
        updateStocks,
      },
      undefined,
      true,
    )
  }

  static deleteRecodeSamson() {
    return this.delete(this.baseUrl + "api/wb/samson/recode", undefined, true)
  }

  static getRecodeSamson() {
    return this.get<{ success: boolean; items: RecodeSamsonWbType[] }>(
      this.baseUrl + "api/wb/samson/recode",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static uploadRecodeSamson(rows: RecodeSamsonWbType[]) {
    return this.post(
      this.baseUrl + "api/wb/samson/recode",
      { rows },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      true,
    )
  }

  static deleteRecodeYaSamson() {
    return this.delete(this.baseUrl + "api/ya/samson/recode", undefined, true)
  }

  static getRecodeYaSamson() {
    return this.get<{ success: boolean; items: RecodeSamsonYaType[] }>(
      this.baseUrl + "api/ya/samson/recode",
      undefined,
      true,
    ).then((resp) => resp.data)
  }

  static uploadRecodeYaSamson(rows: RecodeSamsonYaType[]) {
    return this.post(
      this.baseUrl + "api/ya/samson/recode",
      { rows },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      true,
    )
  }

  static loadSamsonReport(date_from: string, date_to: string) {
    return this.get<{ success: boolean; report: any[] }>(
      this.baseUrl + "api/samson/report",
      {
        params: {
          date_from,
          date_to,
        },
      },
      true,
    ).then((resp) => resp.data)
  }

  static updateStorages(marketplace: MARKETPLACE) {
    return this.get(
      this.baseUrl + "api/storages/update",
      {
        params: {
          marketplace,
        },
      },
      true,
    )
  }

  static changeStorages(
    marketplace: MARKETPLACE,
    data: { hiddenStorageIds: (string | number)[] },
  ) {
    return this.put(this.baseUrl + "api/storages", { marketplace, data })
  }

  static storages() {
    return this.get(this.baseUrl + "api/updateStoksState", undefined, false)
  }

  static deletePromoDataWB() {
    return this.delete(this.baseUrl + "api/wb/promo", undefined, true)
  }

  static savePromoDataWB(
    data: {
      planPrice: number
      nmId: number
    }[],
  ) {
    return this.post(
      this.baseUrl + "api/wb/promo",
      {
        nomenclatures: data,
      },
      undefined,
      true,
    )
  }

  static cardsToTrashWB(nmIds: number[]) {
    return this.post(this.baseUrl + "api/wb/cards/trash", {
      nmIds,
    })
  }

  static updateWbCards(
    cards: {
      article: string | number
      description?: string
      brand?: string
      name?: string
      tnved?: string
      vat?: string
      length?: string
      width?: string
      height?: string
      weightBrutto?: string
      tradeName?: string
      gtin?: string
      barcode?: string
      overwriteBarcodes?: boolean
      kizMarked?: string
      documents?: {
        type: number
        number?: string
        productNumber?: string
        tradeName?: string
        applicant?: string
        startDate?: string
        endDate?: string
        isEndless?: boolean
      }[]
      excludeDocuments?: boolean
    }[],
  ) {
    return this.post(this.baseUrl + "api/wb/cards/update", {
      cards,
    })
  }

  static updateWbMedia(
    cards: {
      article: string | number
      photos: string[]
    }[],
  ) {
    return this.post(this.baseUrl + "api/wb/cards/media", {
      cards,
    })
  }

  static getWBTokenStatus() {
    return this.get<{
      success: boolean
      blocking: string[]
      nonBlocking: string[]
      tokenInfo: WbTokenInfo | null
    }>(this.baseUrl + "api/wb/token/status")
  }

  static setToken(
    marketplace: MARKETPLACE | SHOP_IDENT,
    data: { token: string; subToken?: string },
  ) {
    return this.post(
      this.baseUrl + "api/set-token",
      { marketplace, data },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      true,
    )
  }

  static reportsState() {
    return this.get(this.baseUrl + "api/report/state", undefined, true)
  }

  static contentState() {
    return this.get(this.baseUrl + "api/content/state", undefined, true)
  }

  static formReport(shop: string, dateFrom: string, dateTo: string) {
    return this.put<{ success: boolean; message?: string }>(
      this.baseUrl + "api/wb/report",
      {
        shop,
        dateFrom,
        dateTo,
      },
    )
  }

  static getReport(date: string) {
    return this.get<{ report: ReportItem[] }>(this.baseUrl + "api/wb/report", {
      params: { date },
    })
  }

  static getReportRange(dateFrom: string, dateTo: string) {
    return this.get<{ report: ReportItem[] }>(
      this.baseUrl + "api/wb/report/range",
      { params: { dateFrom, dateTo } },
    )
  }

  static deleteReport(shop: string, dateFrom: string, dateTo: string) {
    return this.delete<{ success: boolean; message?: string }>(
      this.baseUrl + "api/wb/report",
      {
        params: { shop, dateFrom, dateTo },
      },
    )
  }

  static getAnalytics(
    dateFrom: string,
    dateTo: string,
    excludeNoCost: boolean,
  ) {
    return this.get<{ success: boolean; data: any }>(
      this.baseUrl + "api/wb/analytics",
      {
        params: {
          dateFrom,
          dateTo,
          excludeNoCost: excludeNoCost ? "true" : "false",
        },
      },
    )
  }

  static feedShopsState() {
    return this.get(this.baseUrl + "api/feedShops/state", undefined, true)
  }

  static shopsState() {
    return this.get(this.baseUrl + "api/shops/state", undefined, true)
  }

  static updateWbStocks(
    shopIdent: string,
    selectedStorageId: string,
    updatePrices: boolean,
    updateStocks: boolean,
    isReturnToPromo?: boolean,
    customArgs?: { [key: string]: boolean },
  ) {
    return this.post(
      this.baseUrl + "api/wb/stocks/update",
      {
        selectedStorageId,
        updatePrices,
        updateStocks,
        isReturnToPromo,
        shopIdent,
        customArgs,
      },
      undefined,
      true,
    )
  }

  static resetWbStocks(selectedStorageId: string, shopIdent: string) {
    return this.post(
      this.baseUrl + "api/wb/stocks/reset",
      { selectedStorageId, shopIdent },
      undefined,
      true,
    )
  }

  static deleteWbRecode(ident: string) {
    return this.delete(
      this.baseUrl + "api/wb/recode",
      { params: { ident } },
      true,
    )
  }

  static uploadWbRecode(shopIdent: string, rows: any[]) {
    return this.post(
      this.baseUrl + "api/wb/recode",
      { shopIdent, rows },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
      true,
    )
  }

  static async getWbRecode<T extends BaseWBRecodeItemType>(
    ident: string,
  ): Promise<T[]> {
    const response = await this.get<{ items: T[] }>(
      this.baseUrl + "api/wb/recode",
      { params: { ident } },
      true,
    )
    return response.data?.items
  }
}

export default BaseApi
